import { X } from 'lucide-react'
import { Button } from '../Button'
import { useFilters } from '../../hooks'
import { useTranslation } from 'react-i18next'

export type FiltersProps = {
  filtersHook: ReturnType<typeof useFilters>
}

export function Filters (props: FiltersProps) {
  const { filters, removeFilter, clearFilters } = props.filtersHook
  const { t } = useTranslation()

  const hasManyFilters = filters.length > 1
  const allFiltersAreDefault = filters.every(filter => filter.value === null || filter.value === undefined)

  return (
    <div className="flex flex-row gap-2 items-center overflow-x-auto whitespace-nowrap" style={{ scrollbarWidth: 'thin' }}>
      {!allFiltersAreDefault && hasManyFilters &&
        <span
          className="text-xs font-semibold opacity-80 hover:underline cursor-pointer px-2"
          onClick={clearFilters}
        >
          Reset
        </span>
      }

      {filters.map((filter, index) => (
        <div key={index} className="badge badge-primary badge-outline badge-soft rounded-full gap-1">
          <span>{filter.name}:</span>
          <span className="font-semibold">{filter.valueLabel}</span>
          {hasManyFilters && filter.valueLabel !== t('All') &&
            <Button
              ghost
              circle
              size='xs'
              className="p-1 hover:bg-primary h-auto hover:text-white"
              onClick={() => removeFilter(filter.name)}
            >
              <X size={12} />
            </Button>
          }
        </div>
      ))}
    </div>
  )
}
